// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HistoryOrdModal_orderModal__DYscF {
  padding: 0;
}
.HistoryOrdModal_orderModal__DYscF .modal__inner {
  height: 100%;
  border-radius: 0;
  max-width: none;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.HistoryOrdModal_orderModal__DYscF .modal__inner .modal__header {
  padding: 24px 16px;
  border: none;
}
.HistoryOrdModal_orderModal__DYscF .modal__inner .modal__body {
  background: #FFF;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 0;
}
.HistoryOrdModal_orderModal__DYscF .modal__inner .modal__body .submitBlock {
  margin-top: auto;
}
.HistoryOrdModal_orderModal__DYscF .options-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 1200px) {
  .HistoryOrdModal_orderModal__DYscF .options-list {
    gap: 24px;
  }
}
.HistoryOrdModal_orderModal__DYscF .checkbox-row p, .HistoryOrdModal_orderModal__DYscF .radio-row p {
  line-height: 114%;
  border: none;
}
.HistoryOrdModal_orderModal__DYscF .HistoryOrdModal_modal-text__wKALt {
  font-size: 14px;
  line-height: 20px;
  color: #54575C;
}
.HistoryOrdModal_orderModal__swipeHandler__UKInF {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.HistoryOrdModal_orderModal__swipeHandler__UKInF span {
  border-radius: 8px;
  background: #FFF;
  width: 88px;
  height: 2px;
  z-index: 2;
  display: block;
  position: relative;
}
.HistoryOrdModal_orderModal__swipeHandler__UKInF::before {
  content: "";
  position: absolute;
  bottom: -5vh;
  left: 0;
  right: 0;
  width: 100%;
  height: 30vh;
  background: transparent;
}
.HistoryOrdModal_orderModal__top__6JOXn {
  width: 100%;
  min-height: 216px;
  height: 55vw;
  max-height: 420px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}
.HistoryOrdModal_orderModal__top__6JOXn .swiper {
  height: 100%;
}
.HistoryOrdModal_orderModal__top__6JOXn .swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  margin: 0 6px;
  background: #D9D9D9;
  opacity: 0.4;
}
.HistoryOrdModal_orderModal__top__6JOXn .swiper-pagination-bullet-active {
  background: #FAFAFA;
  opacity: 1;
}
.HistoryOrdModal_orderModal__top__6JOXn .swiper-slide {
  width: 100%;
}
.HistoryOrdModal_orderModal__top__6JOXn .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.HistoryOrdModal_orderModal__roundedTop__7U563 {
  border-radius: 16px 16px 0 0;
}
.HistoryOrdModal_orderModal__body__ggPjk {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px 16px 0 0;
  padding: 0 16px;
}
.HistoryOrdModal_orderModal__body_load__\\+V5v0 {
  gap: initial;
}
.HistoryOrdModal_orderModal__block__2X0QJ {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 5px;
}
@media (min-width: 1200px) {
  .HistoryOrdModal_orderModal__block__2X0QJ {
    margin-bottom: 24px;
  }
}
.HistoryOrdModal_orderModal__blockTitle__Qk6zh {
  font-size: 16px;
  font-weight: 500;
  line-height: 114%;
  padding-bottom: 4px;
}
@media (min-width: 640px) {
  .HistoryOrdModal_orderModal__blockTitle__Qk6zh {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .HistoryOrdModal_orderModal__blockTitle__Qk6zh {
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
  }
}
.HistoryOrdModal_orderModal__blockTitle__Qk6zh::first-letter {
  text-transform: capitalize;
}
.HistoryOrdModal_orderModal__blockRequired__vodzt {
  color: #f2200d;
}
.HistoryOrdModal_orderModal__submitBlock__iQUo1 {
  padding: 16px;
  bottom: 0;
  left: 50%;
  background: #FFF;
  z-index: 2;
  position: sticky;
  width: 100%;
}
.HistoryOrdModal_orderModal__submitBlockHead__DGJOb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.HistoryOrdModal_orderModal__submitBlockHead__DGJOb h5 {
  color: #151B26;
  line-height: 114%;
  font-size: 14px;
  font-weight: 600;
}
.HistoryOrdModal_orderModal__submitBlockHead__DGJOb p {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 114%;
  letter-spacing: -0.24px;
}
.HistoryOrdModal_orderModal__submitBlockBottom__MkY-t {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}
.HistoryOrdModal_orderModal__calc__D\\+Fzr {
  height: 44px;
  width: 88px;
  min-width: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #EEE;
  margin-right: 12px;
}
.HistoryOrdModal_orderModal__calcPlus__Ev3vm, .HistoryOrdModal_orderModal__calcMinus__Xw6CT {
  width: 16px;
  height: 20px;
  display: flex;
  align-items: center;
}
.HistoryOrdModal_orderModal__calcPlus__Ev3vm:disabled, .HistoryOrdModal_orderModal__calcMinus__Xw6CT:disabled {
  opacity: 0.5;
}
.HistoryOrdModal_orderModal__calcNum__i9Ejp {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #000;
  width: 32px;
  margin: 0 4px;
  text-align: center;
}
.HistoryOrdModal_orderModal__picker__xxhSE {
  width: 100%;
  position: relative;
}
.HistoryOrdModal_orderModal__picker__xxhSE img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
@media (min-width: 640px) {
  .HistoryOrdModal_orderModal__picker__xxhSE img {
    right: 20px;
    width: 32px;
    height: 32px;
  }
}
@media (min-width: 1200px) {
  .HistoryOrdModal_orderModal__picker__xxhSE img {
    width: 22px;
    height: 22px;
    right: 10px;
  }
}
.HistoryOrdModal_orderModal__picker__xxhSE input[type=date]::-webkit-inner-spin-button,
.HistoryOrdModal_orderModal__picker__xxhSE input[type=datetime-local]::-webkit-inner-spin-button,
.HistoryOrdModal_orderModal__picker__xxhSE input[type=date]::-webkit-calendar-picker-indicator,
.HistoryOrdModal_orderModal__picker__xxhSE input[type=datetime-local]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appearance: none;
}
.HistoryOrdModal_orderModal__picker__xxhSE input[type=date], .HistoryOrdModal_orderModal__picker__xxhSE input[type=datetime-local] {
  -webkit-appearance: none;
  width: -webkit-fill-available;
}
.HistoryOrdModal_orderModal__picker__xxhSE input[type=date]:not(.HistoryOrdModal_has_value__qKXp2):before,
.HistoryOrdModal_orderModal__picker__xxhSE input[type=datetime-local]:not(.HistoryOrdModal_has_value__qKXp2):before {
  content: attr(placeholder);
  color: #BEC0C2;
  width: 100%;
}
.HistoryOrdModal_orderModal__picker__xxhSE input[type=date]::after,
.HistoryOrdModal_orderModal__picker__xxhSE input[type=datetime-local]::after {
  position: absolute;
  right: 0;
  content: "";
  width: 20px;
  height: 100%;
  background: white;
  border-radius: 8px;
  border-radius: 8px;
}
.HistoryOrdModal_orderModal__picker__xxhSE input {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #E8ECEE;
  background: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 3px 10px;
  position: relative;
}
@media (min-width: 640px) {
  .HistoryOrdModal_orderModal__picker__xxhSE input {
    height: 64px;
    padding-left: 32px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .HistoryOrdModal_orderModal__picker__xxhSE input {
    height: 38px;
    padding-left: 10px;
    font-size: var(--fz-md);
    line-height: normal;
  }
}
.HistoryOrdModal_orderModal__picker__xxhSE input::placeholder {
  color: #BEC0C2;
}
.HistoryOrdModal_orderModal__picker__xxhSE .react-datepicker-wrapper {
  width: 100%;
}
.HistoryOrdModal_orderModal__sk1__QAuEn, .HistoryOrdModal_orderModal__sk2__bChF7, .HistoryOrdModal_orderModal__sk3__jri-G, .HistoryOrdModal_orderModal__sk4__dXOxl {
  border-radius: 2px;
  height: 13px;
  width: 100%;
  margin-top: 8px;
}
.HistoryOrdModal_orderModal__sk2__bChF7 {
  width: 85%;
  margin-top: 10px;
}
.HistoryOrdModal_orderModal__sk3__jri-G {
  width: 50%;
  margin-top: 10px;
}
.HistoryOrdModal_orderModal__sk4__dXOxl {
  width: 20%;
  margin-top: 16px;
  margin-bottom: 9px;
}
.HistoryOrdModal_orderModal__sk5__eQBR5 {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 4px;
  padding-top: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #F3F2F2;
}
.HistoryOrdModal_orderModal__sk5__eQBR5 span {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: block;
  margin-top: 4px;
  margin-bottom: 4px;
}
.HistoryOrdModal_orderModal__sk5__eQBR5 div {
  border-radius: 2px;
  height: 14px;
  width: calc(100% - 34px);
}
.HistoryOrdModal_orderModal__info__SGgBp {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.HistoryOrdModal_orderModal__infoTitle__ubMmQ {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  color: var(--text-color);
}
.HistoryOrdModal_orderModal__infoText__bvL3U {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  word-wrap: break-word;
}
.HistoryOrdModal_orderModal__infoText__bvL3U a {
  color: var(--accent-color);
  text-decoration: underline;
}
.HistoryOrdModal_orderModal__infoText__bvL3U ul, .HistoryOrdModal_orderModal__infoText__bvL3U ol {
  margin: 0;
  padding: 0;
  padding-left: 16px;
}
.HistoryOrdModal_orderModal__infoText__bvL3U img {
  max-width: 100%;
}
.HistoryOrdModal_orderModal__infoText__bvL3U table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.HistoryOrdModal_orderModal__infoText__bvL3U table td, .HistoryOrdModal_orderModal__infoText__bvL3U table th {
  min-width: 1em;
  border: 2px solid #ced4da;
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
.HistoryOrdModal_orderModal__infoText__bvL3U table td > *, .HistoryOrdModal_orderModal__infoText__bvL3U table th > * {
  margin-bottom: 0;
}
.HistoryOrdModal_orderModal__infoText__bvL3U table th {
  font-weight: 700;
  text-align: left;
  background-color: #f1f3f5;
}
.HistoryOrdModal_orderModal__infoText__bvL3U p {
  min-height: 20px;
}
.HistoryOrdModal_orderModal__infoText__bvL3U h1, .HistoryOrdModal_orderModal__infoText__bvL3U h2, .HistoryOrdModal_orderModal__infoText__bvL3U h3 {
  color: #303030;
}
.HistoryOrdModal_orderModal__infoText__bvL3U pre {
  background: #2b2a2a;
  color: #fff;
  padding: 8px;
  display: flex;
  border-radius: 8px;
  width: 100%;
  white-space: pre-wrap;
}
.HistoryOrdModal_orderModal__infoText__bvL3U code {
  width: 100%;
  display: block;
  color: #fff;
  background-color: #f1f3f5;
}
.HistoryOrdModal_orderModal__files__yXTjR {
  padding-top: 8px;
}
.HistoryOrdModal_orderModal__files__yXTjR .orderModal__file {
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 8px 32px 8px 4px;
  border-radius: 12px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: var(--transition);
  margin-bottom: 8px;
}
.HistoryOrdModal_orderModal__files__yXTjR .orderModal__file img {
  width: 15px;
  height: 21px;
}
.HistoryOrdModal_orderModal__file__jA8SB {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 8px;
  padding: 8px 32px 8px 4px;
  background: var(--white);
  border-radius: 12px;
  border: 1px solid transparent;
  position: relative;
  transition: var(--transition);
}
@media (hover: hover) {
  .HistoryOrdModal_orderModal__file__jA8SB:hover {
    border-color: var(--accent-color);
  }
}
.HistoryOrdModal_orderModal__fileContent__zT45W {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: var(--transition);
}
.HistoryOrdModal_orderModal__fileContent__zT45W img {
  max-width: 24px;
  min-width: 24px;
}
.HistoryOrdModal_orderModal__fileIsLoading__loader__nl23- {
  height: 3px;
  background: #4084F8;
}
.HistoryOrdModal_orderModal__fileName__RZtV6 {
  font-size: var(--fz-md);
  line-height: var(--lh-md);
}
.HistoryOrdModal_orderModal__fileSize__eonEG {
  font-size: var(--fz-sm);
  line-height: 1;
  color: #7A808B;
  margin-top: 2px;
}
.HistoryOrdModal_orderModal__fileDelete__XcYsd {
  margin-left: auto;
  color: var(--error);
}
.HistoryOrdModal_orderModal__object__bGvEA {
  border-radius: 12px;
  background: #FAFAFA;
  padding: 8px;
  display: flex;
  align-items: center;
}
.HistoryOrdModal_orderModal__objectIco__cY4vU {
  width: 26px;
  min-width: 26px;
  height: 26px;
  margin-right: 8px;
}
.HistoryOrdModal_orderModal__objectText__pRFsG span {
  font-size: 14px;
  line-height: 114%;
  color: #7A808B;
}
.HistoryOrdModal_orderModal__objectText__pRFsG p {
  font-size: 16px;
  color: #101618;
  line-height: 23.04px;
}
.HistoryOrdModal_orderModal__objectArrow__n4D-T {
  margin-left: auto;
}
@media (min-width: 640px) {
  .HistoryOrdModal_orderModal__top__6JOXn .swiper-pagination {
    bottom: 24px;
  }
  .HistoryOrdModal_orderModal__top__6JOXn .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    margin: 0 12px;
    background: #D9D9D9;
    opacity: 0.4;
  }
  .HistoryOrdModal_orderModal__top__6JOXn .swiper-pagination-bullet-active {
    background: #FAFAFA;
    opacity: 1;
  }
  .HistoryOrdModal_orderModal__body__ggPjk {
    padding: 16px 24px 0;
  }
  .HistoryOrdModal_orderModal__submitBlock__iQUo1 {
    padding: 24px;
    margin-left: -24px;
  }
  .HistoryOrdModal_orderModal__submitBlockHead__DGJOb h5 {
    font-size: 32px;
  }
  .HistoryOrdModal_orderModal__submitBlockHead__DGJOb p {
    font-size: 28px;
    letter-spacing: -0.56px;
  }
  .HistoryOrdModal_orderModal__submitBlockBottom__MkY-t {
    margin-top: 18px;
  }
  .HistoryOrdModal_orderModal__calc__D\\+Fzr {
    border-radius: 16px;
    width: 195px;
    min-width: 195px;
    height: 76px;
    margin-right: 16px;
  }
  .HistoryOrdModal_orderModal__calcNum__i9Ejp {
    width: 59px;
    height: 22px;
    margin: 0 16px;
    font-size: 28px;
  }
  .HistoryOrdModal_orderModal__calcPlus__Ev3vm, .HistoryOrdModal_orderModal__calcMinus__Xw6CT {
    width: 32px;
    height: 32px;
  }
  .HistoryOrdModal_orderModal__calcPlus__Ev3vm svg, .HistoryOrdModal_orderModal__calcMinus__Xw6CT svg {
    width: 32px;
    height: 32px;
  }
}
.HistoryOrdModal_orderModal__inputError__ArYFX.HistoryOrdModal_orderModal__inputError__ArYFX {
  border-color: #F2200D;
}
.HistoryOrdModal_orderModal__time__Txz8H {
  font-size: 12px;
  padding: 2px 4px;
  min-height: auto;
}

.HistoryOrdModal_photoBlock__LqQgV {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(3, 1fr);
}
@media (min-width: 1200px) {
  .HistoryOrdModal_photoBlock__LqQgV {
    grid-template-columns: repeat(6, 1fr);
  }
}
.HistoryOrdModal_photoBlock__append__Ev9uV {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 105px;
  cursor: pointer;
  background: rgba(var(--accent-color-rgb), 0.1);
}
.HistoryOrdModal_photoBlock__append__Ev9uV.HistoryOrdModal_error__iTY1V {
  border: 1px solid #F2200D;
}
.HistoryOrdModal_photoBlock__plus__TTA94 {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--accent-color);
  color: var(--accent-text-color);
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.HistoryOrdModal_photoBlock__preview__482Dl {
  height: 105px;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.HistoryOrdModal_photoBlock__preview__482Dl > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.HistoryOrdModal_photoBlock__close__EplfP {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: #E97676;
}
@media (min-width: 640px) {
  .HistoryOrdModal_photoBlock__append__Ev9uV, .HistoryOrdModal_photoBlock__preview__482Dl {
    height: 140px;
  }
}
@media (min-width: 1200px) {
  .HistoryOrdModal_photoBlock__append__Ev9uV, .HistoryOrdModal_photoBlock__preview__482Dl {
    height: 104px;
  }
}
.HistoryOrdModal_photoBlock__camera__Fa9MM {
  color: rgba(var(--accent-color-rgb), 0.45);
}

@media (min-width: 1200px) {
  label.HistoryOrdModal_checkboxAlone__7BbEc {
    flex-direction: row-reverse;
    justify-content: flex-end;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  label.HistoryOrdModal_checkboxAlone__7BbEc p {
    width: auto;
    font-weight: 500;
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
    padding-top: 5px;
    margin-right: 8px;
  }
}

@media (min-width: 1200px) {
  .HistoryOrdModal_orderModal__block__2X0QJ .HistoryOrdModal_checkboxAlone__7BbEc p:last-child {
    margin-left: 0;
  }
}

.HistoryOrdModal_conditionList__SrsDA {
  position: initial;
  overflow: hidden;
  transition: 0.15s;
}

.HistoryOrdModal_conditionList__container__9Vm1m {
  display: flex;
  flex-direction: column;
}
@media (max-width: 1200px) {
  .HistoryOrdModal_conditionList__container__9Vm1m {
    gap: 24px;
  }
}

.HistoryOrdModal_qrBlock__Y1R5s {
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #EAF7EF;
  width: max-content;
  cursor: pointer;
}
.HistoryOrdModal_qrBlock__Y1R5s svg {
  width: 13px;
  height: 13px;
}
.HistoryOrdModal_qrBlock__Y1R5s svg path {
  fill: #2DBE64;
}

.HistoryOrdModal_QRInput__aq8jC {
  position: relative;
}
.HistoryOrdModal_QRInput__aq8jC input:disabled {
  background: none;
}
.HistoryOrdModal_QRInput__icon__bgRC8 {
  position: absolute;
  top: calc(50% - 16px);
  right: 10px;
  background: none;
}

.HistoryOrdModal_historyOrdModal__fwU\\+I {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.HistoryOrdModal_historyOrdModal__top__UC6Xs {
  padding-bottom: 12px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f2f2;
}
.HistoryOrdModal_historyOrdModal__topImg__IcuNl {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 8px;
}
.HistoryOrdModal_historyOrdModal__topImg_small__BBJ8p {
  width: 38px;
  height: 38px;
}
.HistoryOrdModal_historyOrdModal__topImg__IcuNl img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.HistoryOrdModal_historyOrdModal__topText__3h\\+VE {
  width: 100%;
}
.HistoryOrdModal_historyOrdModal__topText__3h\\+VE p {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 114%;
  letter-spacing: -0.24px;
  color: #54575C;
}
.HistoryOrdModal_historyOrdModal__topText__3h\\+VE > div {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  color: #000;
}
.HistoryOrdModal_historyOrdModal__topText__3h\\+VE > div span {
  font-weight: 400;
  margin-left: 6px;
}
.HistoryOrdModal_historyOrdModal__topText__3h\\+VE > div div:last-of-type {
  border-bottom: none;
}
.HistoryOrdModal_historyOrdModal__topText__3h\\+VE h5 {
  font-size: 16px;
  font-weight: 400;
  line-height: 144%;
}
.HistoryOrdModal_historyOrdModal__line__\\+AOhX {
  border-bottom: 1px solid #f3f2f2;
  margin-top: 8px;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.HistoryOrdModal_historyOrdModal__doubleline__W5Z\\+\\+ > div {
  width: calc(50% - 4px);
}
.HistoryOrdModal_historyOrdModal__executorDescr__5lNjE {
  margin-left: 8px;
  width: 100%;
}
.HistoryOrdModal_historyOrdModal__executorDescr__5lNjE label svg {
  width: 26px;
}
.HistoryOrdModal_historyOrdModal__executorDescr__5lNjE p {
  font-size: 12px;
  line-height: 144%;
  letter-spacing: -0.24px;
}
.HistoryOrdModal_historyOrdModal__bottom__lnkDg {
  margin-top: auto;
  padding-bottom: 24px;
}
.HistoryOrdModal_historyOrdModal__bottom__lnkDg .btn_orange {
  margin-bottom: 16px;
}
.HistoryOrdModal_historyOrdModal__bottomTwoBtns__6UFSI {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 16px;
}
.HistoryOrdModal_historyOrdModal__bottomTwoBtns__6UFSI button {
  gap: 0 4px;
  width: 50%;
  padding: 0 34px;
}
.HistoryOrdModal_historyOrdModal__nameSk__ggfin {
  border-radius: 4px;
  width: 155px;
  height: 26px;
}
.HistoryOrdModal_historyOrdModal__text1Sk__jFtqW {
  width: 43px;
  height: 12px;
  border-radius: 4px;
  margin-bottom: 6px;
}
.HistoryOrdModal_historyOrdModal__text2Sk__UlyE2 {
  width: 191px;
  height: 14px;
  border-radius: 4px;
}
.HistoryOrdModal_historyOrdModal__btnSk__nXAKe {
  width: 100%;
  border-radius: 12px;
  height: 44px;
}
.HistoryOrdModal_historyOrdModal__informText__R6cnA {
  margin-top: 12px;
  margin-bottom: 12px;
}

.HistoryOrdModal_photoBlock__LqQgV {
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f2f2;
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/OrderModal/OrderModal.module.scss","webpack://./src/components/Modals/HistoryOrdModal/HistoryOrdModal.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;ACCF;ADEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ACAN;ADEM;EACE,kBAAA;EACA,YAAA;ACAR;ADGM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;ACDR;ADGQ;EACE,gBAAA;ACDV;ADMI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACJN;ADMM;EALF;IAMI,SAAA;ECHN;AACF;ADOM;EACE,iBAAA;EACA,YAAA;ACLR;ADUE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ACRJ;ADWE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;ACTJ;ADUI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;ACRN;ADUI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;ACRN;ADYE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;ACVJ;ADaM;EACE,YAAA;ACXR;ADaU;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ACXZ;ADaY;EACE,mBAAA;EACA,UAAA;ACXd;ADgBQ;EACE,WAAA;ACdV;ADeU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;ACbZ;ADoBE;EACE,4BAAA;AClBJ;ADqBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,4BAAA;EACA,eAAA;ACnBJ;ADqBI;EACE,YAAA;ACnBN;ADsBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;ACpBJ;ADsBI;EANF;IAOI,mBAAA;ECnBJ;AACF;ADsBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;ACpBJ;ADsBI;EANF;IAOI,eAAA;ECnBJ;AACF;ADqBI;EAVF;IAWI,uBAAA;IACA,yBAAA;EClBJ;AACF;ADoBI;EACE,0BAAA;AClBN;ADsBE;EACE,cAAA;ACpBJ;ADuBE;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;ACrBJ;ADwBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACtBJ;ADuBI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;ACrBN;ADuBI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ACrBN;ADyBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;ACvBJ;AD0BE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;ACxBJ;AD2BE;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AC1BJ;AD2BI;EACE,YAAA;ACzBN;AD6BE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AC3BJ;AD8BE;EACE,WAAA;EACA,kBAAA;AC5BJ;AD8BI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AC5BN;AD8BM;EANF;IAOI,WAAA;IACA,WAAA;IACA,YAAA;EC3BN;AACF;AD6BM;EAZF;IAaI,WAAA;IACA,YAAA;IACA,WAAA;EC1BN;AACF;AD6BI;;;;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AC3BN;AD8BK;EACC,wBAAA;EACA,6BAAA;AC5BN;ADgCI;;EAEE,0BAAA;EACA,cAAA;EACA,WAAA;AC9BN;ADkCI;;EAEE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AChCN;ADqCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ACnCN;ADqCM;EAbF;IAcI,YAAA;IACA,kBAAA;IACA,eAAA;EClCN;AACF;ADoCM;EAnBF;IAoBI,YAAA;IACA,kBAAA;IACA,uBAAA;IACA,mBAAA;ECjCN;AACF;ADmCM;EACE,cAAA;ACjCR;ADsCM;EACE,WAAA;ACpCR;ADyCE;EAIE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AC1CJ;AD6CE;EACE,UAAA;EACA,gBAAA;AC3CJ;AD8CE;EACE,UAAA;EACA,gBAAA;AC5CJ;AD+CE;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;AC7CJ;ADgDE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;AC9CJ;AD+CI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AC7CN;ADgDI;EACE,kBAAA;EACA,YAAA;EACA,wBAAA;AC9CN;ADkDE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AChDJ;ADmDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;ACjDJ;ADoDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AClDJ;ADoDI;EACE,0BAAA;EACA,0BAAA;AClDN;ADoDI;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AClDN;ADqDI;EACE,eAAA;ACnDN;ADqDI;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;ACnDN;ADsDI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ACpDN;ADuDI;EACE,gBAAA;ACrDN;ADwDI;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;ACtDN;ADyDI;EACE,gBAAA;ACvDN;AD0DI;EAGE,cAAA;AC1DN;AD4DI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AC1DN;AD4DI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;AC1DN;AD8DE;EACE,gBAAA;AC5DJ;ADgEQ;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AC9DV;ADgEU;EACE,WAAA;EACA,YAAA;AC9DZ;ADqEE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;ACnEJ;ADqEI;EACE;IACE,iCAAA;ECnEN;AACF;ADuEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,6BAAA;ACrEJ;ADuEI;EACE,eAAA;EACA,eAAA;ACrEN;AD0EI;EACE,WAAA;EACA,mBAAA;ACxEN;AD4EE;EACE,uBAAA;EACA,yBAAA;AC1EJ;AD6EE;EACE,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AC3EJ;AD8EE;EACE,iBAAA;EACA,mBAAA;AC5EJ;AD+EE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AC7EJ;AD+EE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AC7EJ;ADgFI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AC9EN;ADiFI;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AC/EN;ADmFE;EACE,iBAAA;ACjFJ;ADoFE;EAKQ;IACE,YAAA;ECtFV;EDuFU;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,mBAAA;IACA,YAAA;ECrFZ;EDuFY;IACE,mBAAA;IACA,UAAA;ECrFd;ED6FE;IACE,oBAAA;EC3FJ;ED8FE;IACE,aAAA;IACA,kBAAA;EC5FJ;EDgGI;IACE,eAAA;EC9FN;EDiGI;IACE,eAAA;IACA,uBAAA;EC/FN;EDmGE;IACE,gBAAA;ECjGJ;EDoGE;IACE,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;EClGJ;EDqGE;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;ECnGJ;EDsGE;IAEE,WAAA;IACA,YAAA;ECrGJ;EDsGI;IACE,WAAA;IACA,YAAA;ECpGN;AACF;ADuGE;EACE,qBAAA;ACrGJ;ADwGE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ACtGJ;;AD0GA;EACE,aAAA;EACA,aAAA;EACA,qCAAA;ACvGF;ADyGE;EALF;IAMI,qCAAA;ECtGF;AACF;ADwGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8CAAA;ACtGJ;ADwGI;EACE,yBAAA;ACtGN;AD0GE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACxGJ;AD2GE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ACzGJ;AD2GI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;ACzGN;AD6GE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AC3GJ;ADgHI;EAFF;IAGI,aAAA;EC7GJ;AACF;AD+GI;EANF;IAOI,aAAA;EC5GJ;AACF;AD+GE;EACE,0CAAA;AC7GJ;;ADkHE;EADF;IAEI,2BAAA;IACA,yBAAA;IACA,eAAA;EC9GF;AACF;ADiHI;EADF;IAEI,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;EC9GJ;AACF;;ADuHU;EADF;IAEI,cAAA;ECnHV;AACF;;AD0HA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;ACvHF;;AD0HA;EACE,aAAA;EACA,sBAAA;ACvHF;ADyHE;EAJF;IAKI,SAAA;ECtHF;AACF;;ADyHA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;ACtHF;ADwHE;EACE,WAAA;EACA,YAAA;ACtHJ;ADwHI;EACE,aAAA;ACtHN;;AD2HA;EACE,kBAAA;ACxHF;AD0HE;EACE,gBAAA;ACxHJ;AD2HE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;ACzHJ;;AAvtBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA0tBF;AAxtBE;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AA0tBJ;AAvtBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAytBJ;AAvtBI;EACE,WAAA;EACA,YAAA;AAytBN;AAttBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAwtBN;AAptBE;EACE,WAAA;AAstBJ;AAptBI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAstBN;AAntBI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAqtBN;AAntBM;EACE,gBAAA;EACA,gBAAA;AAqtBR;AAltBM;EACE,mBAAA;AAotBR;AAhtBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAktBN;AA9sBE;EACE,gCAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAgtBJ;AA5sBI;EACE,sBAAA;AA8sBN;AA1sBE;EACE,gBAAA;EACA,WAAA;AA4sBJ;AA1sBM;EACE,WAAA;AA4sBR;AAzsBI;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;AA2sBN;AAvsBE;EACE,gBAAA;EACA,oBAAA;AAysBJ;AAtsBM;EACE,mBAAA;AAwsBR;AAnsBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAqsBJ;AAnsBI;EACE,UAAA;EACA,UAAA;EACA,eAAA;AAqsBN;AAjsBE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AAmsBJ;AAhsBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAksBJ;AA/rBE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AAisBJ;AA9rBE;EACE,WAAA;EACA,mBAAA;EACA,YAAA;AAgsBJ;AA7rBE;EACE,gBAAA;EACA,mBAAA;AA+rBJ;;AA3rBA;EACE,oBAAA;EACA,gCAAA;EACA,kBAAA;AA8rBF","sourcesContent":[".orderModal {\n  padding: 0;\n\n  :global {\n    .modal__inner {\n      height: 100%;\n      border-radius: 0;\n      max-width: none;\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n\n      .modal__header {\n        padding: 24px 16px;\n        border: none;\n      }\n\n      .modal__body {\n        background: #FFF;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        overflow: auto;\n        padding: 0;\n\n        .submitBlock {\n          margin-top: auto;\n        }\n      }\n    }\n\n    .options-list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      @media (max-width: 1200px) {\n        gap: 24px;\n      }\n    }\n\n    .checkbox-row, .radio-row {\n      p {\n        line-height: 114%;\n        border: none;\n      }\n    }\n  }\n\n  .modal-text {\n    font-size: 14px;\n    line-height: 20px;\n    color: #54575C;\n  }\n\n  &__swipeHandler {\n    position: absolute;\n    top: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    height: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n    span {\n      border-radius: 8px;\n      background: #FFF;\n      width: 88px;\n      height: 2px;\n      z-index: 2;\n      display: block;\n      position: relative;\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      bottom: -5vh;\n      left: 0;\n      right: 0;\n      width: 100%;\n      height: 30vh;\n      background: transparent;\n    }\n  }\n\n  &__top {\n    width: 100%;\n    min-height: 216px;\n    height: 55vw;\n    max-height: 420px;\n    border-radius: 16px 16px 0 0;\n    overflow: hidden;\n\n    :global {\n      .swiper {\n        height: 100%;\n        &-pagination {\n          &-bullet {\n            width: 6px;\n            height: 6px;\n            margin: 0 6px;\n            background: #D9D9D9;\n            opacity: 0.4;\n\n            &-active {\n              background: #FAFAFA;\n              opacity: 1;\n            }\n          }\n        }\n\n        &-slide {\n          width: 100%;\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            object-position: center;\n          }\n        }\n      }\n    }\n  }\n\n  &__roundedTop {\n    border-radius: 16px 16px 0 0;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    border-radius: 16px 16px 0 0;\n    padding: 0 16px;\n\n    &_load {\n      gap: initial;\n    }\n  }\n  &__block {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 5px;\n\n    @media (min-width: 1200px) {\n      margin-bottom: 24px;\n    }\n  }\n\n  &__blockTitle {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 114%;\n    padding-bottom: 4px;\n\n    @media (min-width: 640px) {\n      font-size: 22px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n    }\n\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n\n  &__blockRequired {\n    color: #f2200d;\n  }\n\n  &__submitBlock {\n    padding: 16px;\n    bottom: 0;\n    left: 50%;\n    background: #FFF;\n    z-index: 2;\n    position: sticky;\n    width: 100%;\n  }\n\n  &__submitBlockHead {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    h5 {\n      color: #151B26;\n      line-height: 114%;\n      font-size: 14px;\n      font-weight: 600;\n    }\n    p {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 114%;\n      letter-spacing: -0.24px;\n    }\n  }\n\n  &__submitBlockBottom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 12px;\n  }\n\n  &__calc {\n    height: 44px;\n    width: 88px;\n    min-width: 88px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    background: #EEE;\n    margin-right: 12px;\n  }\n\n  &__calcPlus,\n  &__calcMinus {\n    width: 16px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n\n  &__calcNum {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    color: #000;\n    width: 32px;\n    margin: 0 4px;\n    text-align: center;\n  }\n\n  &__picker {\n    width: 100%;\n    position: relative;\n\n    img {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 10px;\n\n      @media (min-width: 640px) {\n        right: 20px;\n        width: 32px;\n        height: 32px;\n      }\n\n      @media (min-width: 1200px) {\n        width: 22px;\n        height: 22px;\n        right: 10px;\n      }\n    }\n\n    input[type=\"date\"]::-webkit-inner-spin-button,\n    input[type=\"datetime-local\"]::-webkit-inner-spin-button,\n    input[type=\"date\"]::-webkit-calendar-picker-indicator,\n    input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      -webkit-appearance: none;\n    }\n\n     input[type=\"date\"], input[type=\"datetime-local\"] {\n      -webkit-appearance: none;\n      width: -webkit-fill-available;\n     }\n\n    // Отображение placeholder у инпутов с типом даты\n    input[type=\"date\"]:not(.has_value):before, \n    input[type=\"datetime-local\"]:not(.has_value):before {\n      content: attr(placeholder);\n      color: #BEC0C2;\n      width: 100%;\n    }\n\n    // Блок для закрытия стрелки на мобилках\n    input[type=\"date\"]::after,\n    input[type=\"datetime-local\"]::after {\n      position: absolute;\n      right: 0;\n      content: \"\";\n      width: 20px;\n      height: 100%;\n      background: white;\n      border-radius: 8px;\n      border-radius: 8px;\n    }\n\n  \n\n    input {\n      width: 100%;\n      height: 40px;\n      border-radius: 8px;\n      border: 1px solid #E8ECEE;\n      background: #FFF;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px;\n      padding: 3px 10px;\n      position: relative;\n\n      @media (min-width: 640px) {\n        height: 64px;\n        padding-left: 32px;\n        font-size: 20px;\n      }\n\n      @media (min-width: 1200px) {\n        height: 38px;\n        padding-left: 10px;\n        font-size: var(--fz-md);\n        line-height: normal;\n      }\n\n      &::placeholder {\n        color: #BEC0C2;\n      }\n    }\n\n    :global {\n      .react-datepicker-wrapper {\n        width: 100%;\n      }\n    }\n  }\n\n  &__sk1,\n  &__sk2,\n  &__sk3,\n  &__sk4 {\n    border-radius: 2px;\n    height: 13px;\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  &__sk2 {\n    width: 85%;\n    margin-top: 10px;\n  }\n\n  &__sk3 {\n    width: 50%;\n    margin-top: 10px;\n  }\n\n  &__sk4 {\n    width: 20%;\n    margin-top: 16px;\n    margin-bottom: 9px;\n  }\n\n  &__sk5 {\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #F3F2F2;\n    span {\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      display: block;\n      margin-top: 4px;\n      margin-bottom: 4px;\n    }\n\n    div {\n      border-radius: 2px;\n      height: 14px;\n      width: calc(100% - 34px);\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__infoTitle {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    color: var(--text-color);\n  }\n\n  &__infoText {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    word-wrap: break-word;\n\n    a {\n      color: var(--accent-color);\n      text-decoration: underline;\n    }\n    ul, ol{\n      margin: 0;\n      padding: 0;\n      padding-left: 16px;\n    }\n\n    img {\n      max-width: 100%;\n    }\n    table {\n      border-collapse: collapse;\n      table-layout: fixed;\n      width: 100%;\n      margin: 0;\n      overflow: hidden\n    }\n\n    table td,table th {\n      min-width: 1em;\n      border: 2px solid #ced4da;\n      padding: 3px 5px;\n      vertical-align: top;\n      box-sizing: border-box;\n      position: relative\n    }\n\n    table td>*,table th>* {\n      margin-bottom: 0\n    }\n\n    table th {\n      font-weight: 700;\n      text-align: left;\n      background-color: #f1f3f5\n    }\n\n    p {\n      min-height: 20px;\n    }\n\n    & h1,\n    & h2,\n    & h3 {\n      color: #303030;\n    }\n    pre {\n      background: #2b2a2a;\n      color: #fff;\n      padding: 8px;\n      display: flex;\n      border-radius: 8px;\n      width: 100%;\n      white-space: pre-wrap;\n    }\n    code {\n      width: 100%;\n      display: block;\n      color: #fff;\n      background-color: #f1f3f5;\n    }\n  }\n\n  &__files {\n    padding-top: 8px;\n\n    :global {\n      .orderModal {\n        &__file {\n          flex-direction: row;\n          flex-wrap: nowrap;\n          padding: 8px 32px 8px 4px;\n          border-radius: 12px;\n          border: 1px solid transparent;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          position: relative;\n          transition: var(--transition);\n          margin-bottom: 8px;\n\n          img {\n            width: 15px;\n            height: 21px;\n          }\n        }\n      }\n    }\n  }\n\n  &__file {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 2px;\n    margin-bottom: 8px;\n    padding: 8px 32px 8px 4px;\n    background: var(--white);\n    border-radius: 12px;\n    border: 1px solid transparent;\n    position: relative;\n    transition: var(--transition);\n\n    @media (hover: hover) {\n      &:hover {\n        border-color: var(--accent-color);\n      }\n    }\n  }\n\n  &__fileContent {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: var(--transition);\n\n    img {\n      max-width: 24px;\n      min-width: 24px;\n    }\n  }\n\n  &__fileIsLoading {\n    &__loader {\n      height: 3px;\n      background: #4084F8;\n    }\n  }\n\n  &__fileName {\n    font-size: var(--fz-md);\n    line-height: var(--lh-md);\n  }\n\n  &__fileSize {\n    font-size: var(--fz-sm);\n    line-height: 1;\n    color: #7A808B;\n    margin-top: 2px;\n  }\n\n  &__fileDelete {\n    margin-left: auto;\n    color: var(--error);\n  }\n\n  &__object {\n    border-radius: 12px;\n    background: #FAFAFA;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n  }\n  &__objectIco {\n    width: 26px;\n    min-width: 26px;\n    height: 26px;\n    margin-right: 8px;\n  }\n  &__objectText {\n    span {\n      font-size: 14px;\n      line-height: 114%;\n      color: #7A808B;\n    }\n\n    p {\n      font-size: 16px;\n      color: #101618;\n      line-height: 23.04px;\n    }\n  }\n\n  &__objectArrow {\n    margin-left: auto;\n  }\n\n  @media (min-width: 640px) {\n\n    &__top {\n      :global {\n        .swiper {\n          &-pagination {\n            bottom: 24px;\n            &-bullet {\n              width: 12px;\n              height: 12px;\n              margin: 0 12px;\n              background: #D9D9D9;\n              opacity: 0.4;\n    \n              &-active {\n                background: #FAFAFA;\n                opacity: 1;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &__body {\n      padding: 16px 24px 0;\n    }\n\n    &__submitBlock {\n      padding: 24px;\n      margin-left: -24px;\n    }\n\n    &__submitBlockHead {\n      h5 {\n        font-size: 32px;\n      }\n\n      p {\n        font-size: 28px;\n        letter-spacing: -0.56px;\n      }\n    }\n\n    &__submitBlockBottom {\n      margin-top: 18px;\n    }\n\n    &__calc {\n      border-radius: 16px;\n      width: 195px;\n      min-width: 195px;\n      height: 76px;\n      margin-right: 16px;\n    }\n\n    &__calcNum {\n      width: 59px;\n      height: 22px;\n      margin: 0 16px;\n      font-size: 28px;\n    }\n\n    &__calcPlus,\n    &__calcMinus {\n      width: 32px;\n      height: 32px;\n      svg {\n        width: 32px;\n        height: 32px;\n      }\n    }\n  }\n  &__inputError.orderModal__inputError{\n    border-color: #F2200D;\n  }\n\n  &__time {\n    font-size: 12px;\n    padding: 2px 4px;\n    min-height: auto;\n  }\n}\n\n.photoBlock {\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: repeat(3, 1fr);\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(6, 1fr);\n  }\n\n  &__append {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    height: 105px;\n    cursor: pointer;\n    background: rgba(var(--accent-color-rgb), 0.1);\n\n    &.error {\n      border: 1px solid #F2200D;\n    }\n  }\n\n  &__plus {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: var(--accent-color);\n    color: var(--accent-text-color);\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__preview {\n    height: 105px;\n    border-radius: 8px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n\n    &>img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  &__close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    background: #E97676;\n  }\n\n  &__append,\n  &__preview {\n    @media (min-width: 640px) {\n      height: 140px;\n    }\n\n    @media (min-width: 1200px) {\n      height: 104px;\n    }\n  }\n\n  &__camera {\n    color: rgba(var(--accent-color-rgb), 0.45)\n  }\n}\n\nlabel.checkboxAlone {\n  @media (min-width: 1200px) {\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    padding-left: 0;\n  }\n\n  p {\n    @media (min-width: 1200px) {\n      width: auto;\n      font-weight: 500;\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n      padding-top: 5px;\n      margin-right: 8px;\n    }\n  }\n}\n\n.orderModal {\n  &__block {\n    .checkboxAlone {\n      p {\n        &:last-child {\n          @media (min-width: 1200px) {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.conditionList {\n  position: initial;\n  overflow: hidden;\n  transition: 0.15s;\n}\n\n.conditionList__container {\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1200px) {\n    gap: 24px;\n  }\n}\n\n.qrBlock {\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #EAF7EF;\n  width: max-content;\n  cursor: pointer;\n\n  svg {\n    width: 13px;\n    height: 13px;\n\n    path {\n      fill: #2DBE64;\n    }\n  }\n}\n\n.QRInput {\n  position: relative;\n\n  input:disabled {\n    background: none;\n  }\n\n  &__icon {\n    position: absolute;\n    top: calc(50% - 16px);\n    right: 10px;\n    background: none;\n  }\n}","@import \"../OrderModal/OrderModal.module.scss\";\n\n.historyOrdModal {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  &__top {\n    padding-bottom: 12px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #f3f2f2;\n  }\n\n  &__topImg {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    margin-right: 8px;\n\n    &_small {\n      width: 38px;\n      height: 38px;\n    }\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  &__topText {\n    width: 100%;\n\n    p {\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 114%;\n      letter-spacing: -0.24px;\n      color: #54575C;\n    }\n\n    & > div {\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 100%;\n      color: #000;\n\n      span {\n        font-weight: 400;\n        margin-left: 6px;\n      }\n\n      div:last-of-type {\n        border-bottom: none;\n      }\n    }\n\n    h5 {\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 144%;\n    }\n  }\n\n  &__line {\n    border-bottom: 1px solid #f3f2f2;\n    margin-top: 8px;\n    padding-bottom: 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__doubleline {\n    & > div {\n      width: calc(50% - 4px);\n    }\n  }\n\n  &__executorDescr {\n    margin-left: 8px;\n    width: 100%;\n    label {\n      svg {\n        width: 26px;\n      }\n    }\n    p {\n      font-size: 12px;\n      line-height: 144%; \n      letter-spacing: -0.24px;\n    }\n  }\n\n  &__bottom {\n    margin-top: auto;\n    padding-bottom: 24px;\n\n    :global {\n      .btn_orange {\n        margin-bottom: 16px;\n      }\n    }\n  }\n\n  &__bottomTwoBtns {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0 16px;\n\n    button {\n      gap: 0 4px;\n      width: 50%;\n      padding: 0 34px;\n    }\n  }\n\n  &__nameSk {\n    border-radius: 4px;\n    width: 155px;\n    height: 26px;\n  }\n\n  &__text1Sk {\n    width: 43px;\n    height: 12px;\n    border-radius: 4px;\n    margin-bottom: 6px;\n  }\n\n  &__text2Sk {\n    width: 191px;\n    height: 14px;\n    border-radius: 4px;\n  }\n\n  &__btnSk {\n    width: 100%;\n    border-radius: 12px;\n    height: 44px;\n  }\n\n  &__informText {\n    margin-top: 12px;\n    margin-bottom: 12px;\n  }\n}\n\n.photoBlock {\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f3f2f2;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderModal": `HistoryOrdModal_orderModal__DYscF`,
	"modal-text": `HistoryOrdModal_modal-text__wKALt`,
	"orderModal__swipeHandler": `HistoryOrdModal_orderModal__swipeHandler__UKInF`,
	"orderModal__top": `HistoryOrdModal_orderModal__top__6JOXn`,
	"orderModal__roundedTop": `HistoryOrdModal_orderModal__roundedTop__7U563`,
	"orderModal__body": `HistoryOrdModal_orderModal__body__ggPjk`,
	"orderModal__body_load": `HistoryOrdModal_orderModal__body_load__+V5v0`,
	"orderModal__block": `HistoryOrdModal_orderModal__block__2X0QJ`,
	"orderModal__blockTitle": `HistoryOrdModal_orderModal__blockTitle__Qk6zh`,
	"orderModal__blockRequired": `HistoryOrdModal_orderModal__blockRequired__vodzt`,
	"orderModal__submitBlock": `HistoryOrdModal_orderModal__submitBlock__iQUo1`,
	"orderModal__submitBlockHead": `HistoryOrdModal_orderModal__submitBlockHead__DGJOb`,
	"orderModal__submitBlockBottom": `HistoryOrdModal_orderModal__submitBlockBottom__MkY-t`,
	"orderModal__calc": `HistoryOrdModal_orderModal__calc__D+Fzr`,
	"orderModal__calcPlus": `HistoryOrdModal_orderModal__calcPlus__Ev3vm`,
	"orderModal__calcMinus": `HistoryOrdModal_orderModal__calcMinus__Xw6CT`,
	"orderModal__calcNum": `HistoryOrdModal_orderModal__calcNum__i9Ejp`,
	"orderModal__picker": `HistoryOrdModal_orderModal__picker__xxhSE`,
	"has_value": `HistoryOrdModal_has_value__qKXp2`,
	"orderModal__sk1": `HistoryOrdModal_orderModal__sk1__QAuEn`,
	"orderModal__sk2": `HistoryOrdModal_orderModal__sk2__bChF7`,
	"orderModal__sk3": `HistoryOrdModal_orderModal__sk3__jri-G`,
	"orderModal__sk4": `HistoryOrdModal_orderModal__sk4__dXOxl`,
	"orderModal__sk5": `HistoryOrdModal_orderModal__sk5__eQBR5`,
	"orderModal__info": `HistoryOrdModal_orderModal__info__SGgBp`,
	"orderModal__infoTitle": `HistoryOrdModal_orderModal__infoTitle__ubMmQ`,
	"orderModal__infoText": `HistoryOrdModal_orderModal__infoText__bvL3U`,
	"orderModal__files": `HistoryOrdModal_orderModal__files__yXTjR`,
	"orderModal__file": `HistoryOrdModal_orderModal__file__jA8SB`,
	"orderModal__fileContent": `HistoryOrdModal_orderModal__fileContent__zT45W`,
	"orderModal__fileIsLoading__loader": `HistoryOrdModal_orderModal__fileIsLoading__loader__nl23-`,
	"orderModal__fileName": `HistoryOrdModal_orderModal__fileName__RZtV6`,
	"orderModal__fileSize": `HistoryOrdModal_orderModal__fileSize__eonEG`,
	"orderModal__fileDelete": `HistoryOrdModal_orderModal__fileDelete__XcYsd`,
	"orderModal__object": `HistoryOrdModal_orderModal__object__bGvEA`,
	"orderModal__objectIco": `HistoryOrdModal_orderModal__objectIco__cY4vU`,
	"orderModal__objectText": `HistoryOrdModal_orderModal__objectText__pRFsG`,
	"orderModal__objectArrow": `HistoryOrdModal_orderModal__objectArrow__n4D-T`,
	"orderModal__inputError": `HistoryOrdModal_orderModal__inputError__ArYFX`,
	"orderModal__time": `HistoryOrdModal_orderModal__time__Txz8H`,
	"photoBlock": `HistoryOrdModal_photoBlock__LqQgV`,
	"photoBlock__append": `HistoryOrdModal_photoBlock__append__Ev9uV`,
	"error": `HistoryOrdModal_error__iTY1V`,
	"photoBlock__plus": `HistoryOrdModal_photoBlock__plus__TTA94`,
	"photoBlock__preview": `HistoryOrdModal_photoBlock__preview__482Dl`,
	"photoBlock__close": `HistoryOrdModal_photoBlock__close__EplfP`,
	"photoBlock__camera": `HistoryOrdModal_photoBlock__camera__Fa9MM`,
	"checkboxAlone": `HistoryOrdModal_checkboxAlone__7BbEc`,
	"conditionList": `HistoryOrdModal_conditionList__SrsDA`,
	"conditionList__container": `HistoryOrdModal_conditionList__container__9Vm1m`,
	"qrBlock": `HistoryOrdModal_qrBlock__Y1R5s`,
	"QRInput": `HistoryOrdModal_QRInput__aq8jC`,
	"QRInput__icon": `HistoryOrdModal_QRInput__icon__bgRC8`,
	"historyOrdModal": `HistoryOrdModal_historyOrdModal__fwU+I`,
	"historyOrdModal__top": `HistoryOrdModal_historyOrdModal__top__UC6Xs`,
	"historyOrdModal__topImg": `HistoryOrdModal_historyOrdModal__topImg__IcuNl`,
	"historyOrdModal__topImg_small": `HistoryOrdModal_historyOrdModal__topImg_small__BBJ8p`,
	"historyOrdModal__topText": `HistoryOrdModal_historyOrdModal__topText__3h+VE`,
	"historyOrdModal__line": `HistoryOrdModal_historyOrdModal__line__+AOhX`,
	"historyOrdModal__doubleline": `HistoryOrdModal_historyOrdModal__doubleline__W5Z++`,
	"historyOrdModal__executorDescr": `HistoryOrdModal_historyOrdModal__executorDescr__5lNjE`,
	"historyOrdModal__bottom": `HistoryOrdModal_historyOrdModal__bottom__lnkDg`,
	"historyOrdModal__bottomTwoBtns": `HistoryOrdModal_historyOrdModal__bottomTwoBtns__6UFSI`,
	"historyOrdModal__nameSk": `HistoryOrdModal_historyOrdModal__nameSk__ggfin`,
	"historyOrdModal__text1Sk": `HistoryOrdModal_historyOrdModal__text1Sk__jFtqW`,
	"historyOrdModal__text2Sk": `HistoryOrdModal_historyOrdModal__text2Sk__UlyE2`,
	"historyOrdModal__btnSk": `HistoryOrdModal_historyOrdModal__btnSk__nXAKe`,
	"historyOrdModal__informText": `HistoryOrdModal_historyOrdModal__informText__R6cnA`
};
export default ___CSS_LOADER_EXPORT___;
